/**
 * Sysadmin Catalog — parent layout (Wave 3 §10.2 #5 / spec §3.3,
 * PR-J amendment 2026-05-08).
 *
 * Sub-tabs:
 *   /sysadmin/catalog/models      v1 (already exists at /sysadmin/models)
 *   /sysadmin/catalog/functions   v1 (PR-G — wrapper-function authoring)
 *   /sysadmin/catalog/mcp         v1 catalog + monitor; v2 promotion queue
 *   /sysadmin/catalog/workflows   v1 (PR-K1 — workflow templates, CLONE)
 *   /sysadmin/catalog/agents      v1 (PR-K2 — agent templates, CLONE)
 *   /sysadmin/catalog/skills      v1 (PR-I — skill templates, ASSIGN)
 *   /sysadmin/catalog/prompts     future
 *
 * PR-J: the planned Knowledge sub-tab was DROPPED. System Library
 * (folders/articles/tags/documents/sources scoped by org_id IS NULL)
 * lives at /sysadmin/library, not under Catalog. The "Knowledge packs"
 * abstraction is replaced by per-row publish lifecycle on existing
 * Library tables.
 *
 * The Models sub-tab deep-links into the existing /sysadmin/models
 * tree so today's Models authoring work isn't lost. When the Catalog
 * IA settles, Models can be physically moved here.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CatalogEntityTabBar } from '@/components/catalog-entity-tabs';

export const Route = createFileRoute('/sysadmin/catalog')({
  component: CatalogLayout,
});

function CatalogLayout() {
  // Entity-tab bar (Models/Functions/MCP/Tools/Workflows/Agents/Skills/Prompts)
  // is the shared <CatalogEntityTabBar/> so the IDENTICAL bar also renders in
  // the Models layout (models.tsx) — clicking Models no longer drops the nav.
  return (
    <div className="flex flex-col h-full">
      <CatalogEntityTabBar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
